import { initializeApp } from 'firebase/app';
import { logDebug } from './loggerService';

const PUSH_DISABLED = import.meta.env.VITE_FIREBASE_PUSH_DISABLED === 'true';

export function initFirebase(): void {
  if (PUSH_DISABLED) {
    logDebug('Firebase initialization skipped — push disabled');
    return;
  }

  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  initializeApp(firebaseConfig);
  logDebug('Firebase initialized');
}
